/* footer: on phones the link columns become an accordion; on larger screens they stay plain, always-open lists */
(function () {
  'use strict';
  var foot = document.querySelector('[data-bz5-foot]');
  if (!foot || foot.__bz5) return;
  foot.__bz5 = true;
  var mq = window.matchMedia('(max-width: 767px)');
  var cols = foot.querySelectorAll('[data-bz5-fcol]');
  var CHEV = '<svg class="i bz5-fcol__chev" viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.8" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M6 9l6 6 6-6"/></svg>';
  var sync = function () {
    Array.prototype.forEach.call(cols, function (c) {
      var h = c.querySelector('.bz5-fcol__h'), list = c.querySelector('ul'), btn = h.querySelector('button');
      if (mq.matches && !btn) {
        btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-controls', list.id);
        btn.innerHTML = CHEV;
        btn.insertBefore(document.createTextNode(h.textContent), btn.firstChild);
        h.textContent = '';
        h.appendChild(btn);
        list.hidden = true;
        btn.addEventListener('click', function () {
          var open = btn.getAttribute('aria-expanded') !== 'true';
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          list.hidden = !open;
        });
      } else if (!mq.matches && btn) {
        h.textContent = btn.textContent;
        list.hidden = false;
      }
    });
  };
  if (mq.addEventListener) mq.addEventListener('change', sync); else if (mq.addListener) mq.addListener(sync);
  sync();
})();